import { Box, Drawer as MUIDrawer, IconButton } from "@mui/material";
import CloseIcon from "assets/CloseIcon";
import { isFunction } from "lodash";
import * as React from "react";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";
interface Props {
  title: string;
  titleCounter: string | number;
  children: any;
  open: boolean;
  setOpen: (val: boolean) => void;
  onClose?: () => void;
}

export default function Drawer(props: Props) {
  const { open, children, title, titleCounter, onClose } = props;

  const onCloseHandler = () => {
    isFunction(onClose) && onClose();
  };

  return (
    <div>
      <React.Fragment key={"drawer"}>
        <MUIDrawer
          anchor={"right"}
          open={open}
          onClose={onCloseHandler}
          PaperProps={{
            sx: {
              width: { xs: "100%", md: "auto" }
            }
          }}
        >
          <Box minWidth={"350px"} maxWidth={"470px"} padding={"25px"} role="presentation" onKeyDown={onCloseHandler}>
            <Box display={"flex"} alignItems="center" marginBottom={2}>
              <Typography variant={"h5"} showBold color={tokens.Text.General.PrimaryHeadline}>
                {title}
              </Typography>
              <Typography variant={"body1"} color={tokens.Text.General.PrimaryHeadline} sx={{ marginLeft: "3px" }}>
                ({titleCounter})
              </Typography>
              <Box marginLeft={"auto"}>
                <IconButton onClick={onCloseHandler}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box display={"flex"} alignItems="center" justifyContent="center" flexDirection={"column"}>
              {children}
            </Box>
          </Box>
        </MUIDrawer>
      </React.Fragment>
    </div>
  );
}
